import { useCallback } from 'react';
import { useFeatureFlagsSafe, type FeatureFlags } from '@/contexts/FeatureFlagsContext';

/**
 * «Is this route's feature known to be off» — what a link asks before it leads
 * to a page `RouteFeatureGate` (`components/ui/FeatureGate`) would answer with
 * «Feature Not Available». The flag context's own verdict: `feature_disabled`.
 * `tier_not_eligible` is not «off»: a screen closed by the plan names the plan
 * and what it gives (`TierLockedScreen`), and that is a reason to open the link,
 * not to hide it — the same in the portal and in Bitrix24. `loading` (the seed
 * only), `failed` (the read failed, or the Bitrix24 session carries a subset and
 * the flag is not in it) and `enabled` are not «off» either — such a link stays.
 * Hand this to `canOpenPath` (`checks.featureOff`) instead of re-deriving the
 * rule from `isEnabled`.
 */
export function useFeatureKnownOff(): (flag: keyof FeatureFlags) => boolean {
  const { gate } = useFeatureFlagsSafe();
  return useCallback((flag) => gate(flag) === 'feature_disabled', [gate]);
}
